import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';
import { FileUploadFile } from 'primereact/fileupload';
import { uploadFileAndRetrieveFileUrl } from '../../../../../../../../../api/operations/files/upload-file-and-retrieve-file-url';
import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const uploadExamQuestionnaireOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number | undefined,
  sessionId: number | undefined,
  file: FileUploadFile | undefined,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
  setDisplayAddDialog: (displayDialog: boolean) => any,
) => {
  try {
    if (!programId || !courseId || !examId || !sessionId) {
      toast.warn('יש לבחור סטודנטים');
      return;
    }
    if (!file) {
      toast.warn('תחילה יש להעלות קובץ');
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (!fileExtension?.length) {
      toast.warn(
        'לא ניתן לאתר את סוג הקובץ, נסה להוסיף סיומת לקובץ והעלאה מחדש',
      );
      return;
    }

    const preSignUrlRes = await appApi.getSessionQuestionnairePreSignUrl(
      programId!,
      courseId!,
      examId!,
      sessionId!,
      fileExtension,
    );

    const fullUrl = await uploadFileAndRetrieveFileUrl(
      preSignUrlRes.data.body,
      file,
    );

    if (!fullUrl) {
      throw new Error('Can not find uploaded path');
    }

    const examDetailsRes = await appApi.uploadExamSessionQuestionnaire(
      programId!,
      courseId!,
      examId!,
      sessionId!,
      fullUrl,
      file.name,
    );

    setSessionDetails(examDetailsRes.data.body);
    setDisplayAddDialog(false);
    // examDetailsRes
    // TODO update state

    toast.success('הפעולה בוצעה בהצלחה', { style: { zIndex: 1 } });
  } catch (e) {
    console.error(
      `uploadExamQuestionnaireOperations is failed with the programId: ${programId}, courseId: ${courseId}, examId: ${examId}, sessionId: ${sessionId} with the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
